import { useContext, useEffect, useRef } from "react";
import globalStates from "../../utils/global";
import "./ShopScreen1.css"
import { ImgProduct1, ImgProduct2, ImgProduct3 } from "../../assets";

const ShopScreen1 = () =>{

    const context = globalStates && globalStates.globalContext;
    const globalContext:any = useContext(context);
    const windowWidthClass = globalContext && globalContext.windowWidthClass;
    
    // const businessDetailImagesImg = businessDetailImages && businessDetailImages.screenBannerImg;

    const screenWebsiteRef = useRef(null) as any;
    // console.log({})
    useEffect(()=>{
        const handleScroll =()=>{
            const setScreensOffset = globalContext && globalContext.setScreensOffset;
            const screenWebsite = screenWebsiteRef.current.getBoundingClientRect();
            const top = screenWebsite.top;
            const bottom = screenWebsite.bottom;
            const offset = globalContext && globalContext.windowHeight;
            setScreensOffset((prev:any)=>{return {...prev, 
                isOffsetscreenWebsite: false, bottom, offset, top
            }});
            if(top < (-1*0.005*offset) ){
                setScreensOffset((prev:any)=>{return {...prev, bottom, offset, top,
                    isOffsetscreenWebsite: true,
                }});
            };
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, [globalContext])

    const componentData = {
        background: {
            image: {
                src: "",
                alt: ""
            }
        },
        shield: {

        },
        content: {
            listProduct: [
                {
                    id: 1,
                    name: "",
                    desc: "Kuno OG Fresh Organic Tempeh is a fermented bean dish from Indonesia. What makes Kuno Tempeh special? It’s made with locally-sourced organic beans from Sweden, combining traditional Indonesian fermentation with local ingredients. Enjoy the hearty, nutty flavor in your favorite dishes.",
                    image: {
                        src: ImgProduct1,
                        alt: ""
                    }
                },
                {
                    id: 2,
                    name: "",
                    desc: "Kuno Sambal is the real deal when it comes to Indonesian sambal. This spicy chili condiment delivers an authentic Indonesian taste, staying true to its origins. Wouldn’t you have guessed that sambal actually comes from Indonesia? Add a bold and fiery touch to your meals with Kuno Sambal.",
                    image: {
                        src: ImgProduct2,
                        alt: ""
                    }
                },
                {
                    id: 3,
                    name: "",
                    desc: "Looking for a good tempeh recipe? Leave the hard work to us! Our Seasonal Spiced Tempeh is easy and ready to serve. Sometimes it comes in Indonesian-style spiced tempeh, and sometimes we get a little daring with fusion flavors – it’s a delicious surprise every time!",
                    image: {
                        src: ImgProduct3,
                        alt: ""
                    }
                }
            ]
        }
    }
    
    return(
        <>
            <div 
            ref={screenWebsiteRef} 
            className={`${windowWidthClass}-shop-screen-1 wrapper`}>

                <div className="background">
                    <div className="frame">
                        {/* <img
                            alt = {componentData.background.image.alt}
                            src = {componentData.background.image.src}
                        /> */}
                    </div>
                </div>
                <div className="shield">

                </div>
                <div className="content display">
                    <div className="wrapper header">
                        <h1>Our Products</h1>
                    </div>
                    <div className="wrapper cardholder">
                        {
                            componentData.content.listProduct.map((product:any, index:any)=>{
                                const {name, desc, image} = product;
                                return (
                                    <div className="grid-item">
                                        <div className="card">
                                            <div className="section frame">
                                                <img 
                                                    src={image.src}
                                                    alt={image.alt}
                                                />
                                            </div>
                                            <div className="section text-wrapper">
                                                <h2>{name}</h2>
                                                <p className="description">{desc}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

            </div>
        </>
        
    )
};

export default ShopScreen1;